// extracted by mini-css-extract-plugin
export default {"imageModal":"ImageModal_imageModal__XCgNd"};